import { Button } from '@mui/material';
import React from 'react';

const LaunchButton = ({ sx = {}, btnName, ...props }) => {
  return (
    <Button
      variant="contained"
      sx={{ ...sx, background: 'white', color: 'black', fontWeight: 'bold', boxShadow: 'none', borderRadius: '5px' }}
      {...props}
    >
      {btnName}
    </Button>
  );
};

export default LaunchButton;
